import { getPressclipping } from '@/graphql/queries/media/pressclipping';

export default async ({ $apolloQuery, app, redirect, route, store }) => {
  await $apolloQuery(getPressclipping, { slug: route.params.slug }).then(podcast => {
    const description = podcast.text;
    const title = podcast.headline;
    store.commit('utils/setPagination');
    store.commit('blog/setPressclipping', podcast);
    store.commit('pageContent/setHead', { description, title });
  }).catch(_ => redirect(301, app.localePath('podcasts')));
};
